/* Ink Kontor — Scroll-Reveals (Framer-Motion-Pattern "whileInView + staggerChildren",
   nativ umgesetzt). Progressive enhancement: ohne dieses Script ist nichts versteckt,
   und ein Rettungsanker zeigt alles, falls der Observer nicht funktioniert. */
(function () {
  'use strict';

  var STAGGER_MS = 70; /* Abstand zwischen Geschwistern (≈ staggerChildren: 0.07) */
  var MAX_DELAY_MS = 420; /* Kappe, damit späte Karten nicht ewig warten */
  var RESCUE_MS = 1500; /* Selbsttest-Frist für den IntersectionObserver */

  if (!('IntersectionObserver' in window)) return;

  /* innerHeight kann in Einbett-Kontexten 0 melden — clientHeight als Fallback.
     Ohne messbaren Viewport: gar nichts verstecken. */
  var vh = Math.max(
    window.innerHeight || 0,
    document.documentElement.clientHeight || 0
  );
  if (!vh) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var targets = [];

  /* Kategorie-/Produktkarten: gestaffelt je Liste */
  document.querySelectorAll('.resource-list').forEach(function (list) {
    list.querySelectorAll('.resource-list__item').forEach(function (el, i) {
      var delay = Math.min(i * STAGGER_MS, MAX_DELAY_MS);
      el.style.setProperty('--ink-d', reduced ? '0ms' : delay + 'ms');
      targets.push(el);
    });
  });

  /* Sektions-Texte einzeln */
  document
    .querySelectorAll('main .section .text-block, main .section h2')
    .forEach(function (el) {
      if (!el.closest('.resource-list')) targets.push(el);
    });

  if (!targets.length) return;

  /* Nach dem Einblenden beide Klassen entfernen — sonst überschreibt die
     600ms-Reveal-Transition dauerhaft die 250ms-Hover-Transition der Karten. */
  function settle(el) {
    el.classList.remove('ink-reveal', 'ink-in');
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          el.classList.add('ink-in');
          el.addEventListener(
            'transitionend',
            function () {
              settle(el);
            },
            { once: true }
          );
          setTimeout(function () {
            settle(el);
          }, 1200); /* Fallback, falls transitionend ausbleibt */
          io.unobserve(el); /* once: true */
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
  );

  targets.forEach(function (el) {
    /* Bereits sichtbare Elemente nie verstecken — kein Aufblitzen beim Laden */
    if (el.getBoundingClientRect().top < vh * 0.85) return;
    el.classList.add('ink-reveal');
    io.observe(el);
  });

  /* Rettungsanker: body schneidet den Viewport immer — feuert der Observer
     darauf nicht binnen RESCUE_MS, ist er defekt → alles sofort zeigen. */
  var ioWorks = false;
  var probe = new IntersectionObserver(function (entries, obs) {
    ioWorks = true;
    obs.disconnect();
  });
  probe.observe(document.body);

  setTimeout(function () {
    if (ioWorks) return;
    io.disconnect();
    document.querySelectorAll('.ink-reveal').forEach(settle);
  }, RESCUE_MS);
})();

/* WhatsApp-Button: schwebend, global. Nummer 0157 33026715 -> intl. 4915733026715. */
(function () {
  'use strict';
  if (document.querySelector('.ink-wa')) return;
  var nummer = '4915733026715';
  var text = encodeURIComponent('Hallo Ink Kontor, ich habe eine Frage.');
  var a = document.createElement('a');
  a.className = 'ink-wa';
  a.href = 'https://wa.me/' + nummer + '?text=' + text;
  a.target = '_blank';
  a.rel = 'noopener';
  a.setAttribute('aria-label', 'Fragen? Schreib uns auf WhatsApp');
  a.innerHTML =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M12 2a10 10 0 0 0-8.6 15l-1.4 5 5.1-1.3A10 10 0 1 0 12 2zm0 18a8 8 0 0 1-4.1-1.1l-.3-.2-3 .8.8-2.9-.2-.3A8 8 0 1 1 12 20zm4.4-6c-.2-.1-1.4-.7-1.6-.8-.2-.1-.4-.1-.5.1-.2.2-.6.8-.7.9-.1.1-.3.2-.5.1-.7-.3-1.4-.6-2-1.4-.2-.3.2-.3.5-.9.1-.1 0-.3 0-.4 0-.1-.5-1.3-.7-1.7-.2-.4-.4-.4-.5-.4h-.5c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 1.9s.8 2.2.9 2.4c.1.1 1.6 2.5 4 3.4.6.3 1 .4 1.4.5.6.2 1.1.2 1.5.1.5-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1 0-.1-.2-.2-.4-.3z"/>' +
    '</svg><span class="ink-wa__text">Fragen? Schreib uns</span>';
  (document.body || document.documentElement).appendChild(a);
})();
